import React, { useEffect, useState } from 'react';
import { useConstructorStore } from '../store/constructorStore';
import { getUserLandings } from '../api/client';
import { t } from '../i18n';

export const MyLandings: React.FC = () => {
  const { language } = useConstructorStore();
  const [landings, setLandings] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const tg = (window as any).Telegram?.WebApp;
    const telegramId = tg?.initDataUnsafe?.user?.id;
    if (!telegramId) return;

    getUserLandings(telegramId)
      .then((res) => setLandings(res.landings || []))
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div style={{ textAlign: 'center', padding: 48, color: '#999' }}>{t('loading', language)}</div>;
  }

  if (landings.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: 48 }}>
        <p style={{ fontSize: 48, marginBottom: 16 }}>📭</p>
        <p style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>{t('no_landings', language)}</p>
        <p style={{ fontSize: 14, color: '#999' }}>{t('create_first', language)}</p>
      </div>
    );
  }

  const statusLabel = (status: string) => {
    switch (status) {
      case 'active': return t('status_active', language);
      case 'draft': return t('status_draft', language);
      case 'disabled': return t('status_disabled', language);
      default: return status;
    }
  };

  const statusColor = (status: string) => {
    switch (status) {
      case 'active': return '#28a745';
      case 'draft': return '#ffc107';
      case 'disabled': return '#dc3545';
      default: return '#999';
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 16 }}>{t('my_landings', language)}</h2>

      {landings.map((landing) => (
        <div key={landing.id} style={{
          background: 'white', borderRadius: 12, padding: 16, marginBottom: 12,
          border: '1px solid #eee',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <h3 style={{ fontSize: 16, fontWeight: 600, margin: 0 }}>{landing.title}</h3>
            <span style={{
              fontSize: 12, fontWeight: 600, color: statusColor(landing.status),
              background: statusColor(landing.status) + '22',
              padding: '3px 8px', borderRadius: 6,
            }}>
              {statusLabel(landing.status)}
            </span>
          </div>
          <p style={{ fontSize: 13, color: '#999', margin: 0 }}>
            📅 {new Date(landing.created_at).toLocaleDateString('ru-RU')}
          </p>
          {landing.url && (
            <a href={landing.url} target="_blank" style={{ fontSize: 14, color: '#0088cc', wordBreak: 'break-all' }}>
              🔗 {landing.url}
            </a>
          )}
        </div>
      ))}
    </div>
  );
};
